import React, { useState } from "react";
import AddNewMedicationModal from "../AddNewMedicationModal";
import { useDisclosure } from "@mantine/hooks";
import useStyles from "../../pages/Home/Medication/style";
import { Box, Button } from "@mantine/core";
import { useSelector } from "react-redux";
import { isStaff } from "../../http";
import { FaPlus } from "react-icons/fa6";

const AddMedicationButton = ({ userId, selectedClient, getClientData }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [medicine, setMedicine] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const { profile } = useSelector((state) => state?.profile);

  const { classes } = useStyles();
  return (
    <>
      <AddNewMedicationModal
        opened={opened}
        onclose={(nType) => {
          close();
          setMedicine(null);
          if (isPreview) setIsPreview(false);
        }}
        data={medicine}
        title={"Chloroquine"}
        userId={userId}
        isPreview={isPreview}
        getClientData={getClientData}
      />       
          {!isStaff(profile?.user?.role) ? (
           <Button
            onClick={() => open()}
            id="add-new-medication"
            disabled={!selectedClient  ? true : false}
            className={classes.addMedicationBtn}
            leftIcon={<FaPlus />}
          >
            Add new Medication
          </Button>
      ) : null}
    </>
  );
};

export default AddMedicationButton;
